import { IStorage } from '@/infra/interfaces/storage/storage';
import { storage } from '@/infra/protocols/storage';

export class LocalStorageAdapter implements IStorage {
  /**
   * Get value from store
   */
  get(key: string) {
    return localStorage.getItem(key) ?? '';
  }

  /**
   * Add or override some value
   */
  add(key: string, value: string) {
    localStorage.setItem(key, value);
  }

  /**
   * Remove value from store
   */
  remove(key: string) {
    localStorage.removeItem(key);
  }

  /**
   * Clear all store
   */
  clear() {
    localStorage.clear();
  }

  /**
   * Clear store, except for specified values
   * @param except values to keep on store
   */
  clearExcept(...except: string[]) {
    const valuesToKeep = except.map((item) => [item, storage.get(item)]);
    storage.clear();
    valuesToKeep.forEach(([key, value]) => {
      if (!key || !value) return;

      storage.add(key, value);
    });
  }

  /**
   * Get and remove some value from store
   */
  take(key: string) {
    const value = storage.get(key);
    storage.remove(key);

    return value;
  }
}
